import { render, staticRenderFns } from "./posts.vue?vue&type=template&id=0ace0b8a&scoped=true&"
import script from "./posts.vue?vue&type=script&lang=js&"
export * from "./posts.vue?vue&type=script&lang=js&"
import style0 from "./posts.vue?vue&type=style&index=0&id=0ace0b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ace0b8a",
  null
  
)

export default component.exports